import { call, put, takeLatest } from "redux-saga/effects"

import {
  GET_SENTIMENT_WORDCLOUD_WATCHER,
  GET_QUALITATIVE_QUESTIONS_WATCHER,
} from "./constants"

import {
  getSentimentWordcloudSuccess,
  getSentimentWordcloudFailed,
  getQualitativeQuestionsSuccess,
  getQualitativeQuestionsFailed,
} from "./actions"
import {
  getSentimentWordcloudApi,
  getListQuestionsApi,
} from "../../../utils/routes/routes-report"

export function* getSentimentWordcloudSaga(params) {
  try {
    const {
      idMeasure,
      measureGeneral,
      idQuestion,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
    } = params.payload

    const isLeadershipMeasure = measureGeneral.id_survey_type === 2

    const requestParams = {
      id_measure: idMeasure,
      "filter[question]": idQuestion || null,
      "filter[leader]": isLeadershipMeasure
        ? idDivisionSelected || idDivisionParent
        : null,
      "filter[type]": measureGeneral.id_measure_type || null,
      id_division: idDivisionSelected || null,
      id_divisionParent: idDivisionParent || null,
      id_segment: selectedSegment || null,
    }

    const response = yield call(getSentimentWordcloudApi, requestParams)
    if (!response) {
      yield put(getSentimentWordcloudSuccess({ total_answers: 0, data: [] }))
      return
    }
    yield put(getSentimentWordcloudSuccess(response))
  } catch (e) {
    yield put(getSentimentWordcloudFailed())
  }
}

export function* getQualitativeQuestionsSaga(params) {
  try {
    const { measureGeneral } = params.payload

    if (measureGeneral.segments.length === 1) {
      params.payload.id_segment = measureGeneral.segments[0].id_segment
      params.payload.id_survey =
        measureGeneral.segments[0].id_survey || measureGeneral.id_survey
    } else if (measureGeneral.segments.length > 1) {
      // Todos los segmentos de una medicion comparten el id_survey real (los
      // "segmentos" filtran las mismas respuestas, no son encuestas distintas).
      // measureGeneral.segments[].id_survey siempre viene poblado, a diferencia
      // de measureGeneral.id_survey (el backend solo lo resuelve cuando la
      // request trae id_segment) o measureTotal.id_survey (idem, solo poblado
      // para el flag 'SMT', no para el 'MT' de la vista General). Se usa el
      // segmento activo si hay uno seleccionado, o el primero disponible para
      // la vista General (VLENG-11404).
      const activeSegment = params.payload.id_segment
        ? measureGeneral.segments.find(
            (segment) => segment.id_segment === params.payload.id_segment
          )
        : measureGeneral.segments[0]
      params.payload.id_survey =
        (activeSegment && activeSegment.id_survey) || measureGeneral.id_survey
    }

    const response = yield call(getListQuestionsApi, params.payload)
    if (!response) {
      yield put(getQualitativeQuestionsSuccess([]))
      return
    }

    const { data: questions } = response
    yield put(
      getQualitativeQuestionsSuccess(questions.filter((q) => q.enabled))
    )
  } catch (e) {
    yield put(getQualitativeQuestionsFailed())
  }
}

export default function* widgetQualitativeBubblesSaga() {
  yield takeLatest(GET_SENTIMENT_WORDCLOUD_WATCHER, getSentimentWordcloudSaga)
  yield takeLatest(
    GET_QUALITATIVE_QUESTIONS_WATCHER,
    getQualitativeQuestionsSaga
  )
}
